import React from 'react'
import './Evolution.css'

const POKEAPI_BASE = 'https://raw.githubusercontent.com/Yarkis01/PokeAPI/images/sprites'

function Evolution() {
  const chains = [
    [
      { name: 'Salamèche', spriteId: 4 },
      { count: 10 },
      { name: 'Reptincel', spriteId: 5 },
      { count: 8 },
      { name: 'Dracaufeu', spriteId: 6 }
    ],
    [
      { name: 'Tylton', spriteId: 333 },
      { count: 30 },
      { name: 'Altaria', spriteId: 334 }
    ]
  ]

  const isLastPokemonInChain = (chain, index) => {
    if (!('name' in chain[index])) return false
    for (let i = index + 1; i < chain.length; i++) {
      if ('name' in chain[i]) return false
    }
    return true
  }

  return (
    <section id="evolution" className="evolution" aria-labelledby="evolution-title">
      <header>
        <h2 id="evolution-title" className="section-title">Système d'Évolution</h2>
        <p className="section-subtitle">
          Farmez vos Pokémon pour les faire évoluer et compléter votre Pokédex
        </p>
      </header>
      <div className="evolution-chains">
        {chains.map((chain, chainIndex) => (
          <div key={chainIndex} className="evolution-chain-single" role="list">
            {chain.map((item, index) =>
              'name' in item ? (
                <article
                  key={index}
                  className={`pokemon-box${isLastPokemonInChain(chain, index) ? ' evolved' : ''}`}
                  role="listitem"
                >
                  <img
                    src={`${POKEAPI_BASE}/${item.spriteId}/regular.png`}
                    alt={item.name}
                    className="pokemon-sprite"
                    width={96}
                    height={96}
                    loading="lazy"
                  />
                  <span className="pokemon-name">{item.name}</span>
                </article>
              ) : (
                <div
                  key={index}
                  className="evolution-arrow"
                  role="presentation"
                  aria-label={`${item.count} exemplaires pour évoluer`}
                >
                  <span className="arrow-icon" aria-hidden="true">→</span>
                  <span className="evolution-count">{item.count}x</span>
                </div>
              )
            )}
          </div>
        ))}
      </div>
      <aside className="evolution-info" role="complementary" aria-label="Information sur le système d'évolution">
        <h3>Comment ça fonctionne ?</h3>
        <p>
          Attrapez plusieurs versions du même Pokémon afin de les faire évoluer. Par exemple, pour obtenir 1 Reptincel, il faut attraper 10 Salamèche, puis 8 Reptincel pour acquérir 1 Dracaufeu. Ou 30 Tylton équivalent à 1 Altaria. C'est l'essence même du farming !
        </p>
      </aside>
    </section>
  )
}

export default Evolution
